import { useContext, useState } from "react";

import { isInLateSubmissionWindow, isPastSubmissionDueDate } from "../helpers";

import { t } from "i18n/i18n";
import { Banner } from "mds/components/Banner";
import { DocViewContext, PageTabVariant } from "providers/DocViewProvider";
import { useAppSelector } from "store";
import { useCapabilities } from "store/capability-hooks";
import { pageSelectors } from "store/selectors";

interface StudentEditingUnsubmittableBannerProps {
  pageId: string;
  selectedTabVariant?: PageTabVariant;
}

export const StudentEditingUnsubmittableBanner = ({
  pageId,
  selectedTabVariant,
}: StudentEditingUnsubmittableBannerProps) => {
  const { canParticipateInSection } = useCapabilities();
  // TODO: we could compute isInLateSubmissionWindow without the entire page object
  // eslint-disable-next-line @minervaproject/no-object-from-use-app-selector/no-object-from-use-app-selector
  const page = useAppSelector((s) => pageSelectors.selectById(s, pageId));
  const [showBanner, setShowBanner] = useState(true);
  const { readOnly } = useContext(DocViewContext);

  const afterSubmissionDueDate = isPastSubmissionDueDate(page) && !isInLateSubmissionWindow(page);

  const showEditingUnsubmittableDraftBanner =
    selectedTabVariant === "my_draft" &&
    canParticipateInSection &&
    !readOnly &&
    afterSubmissionDueDate;

  if (!showEditingUnsubmittableDraftBanner) {
    return null;
  }

  return showBanner ? (
    <Banner className="page-block-width" kind="warning" onDismiss={() => setShowBanner(false)}>
      {t("warning.editing_unsubmittable_draft")}
    </Banner>
  ) : null;
};
